import React from "react";
import { Route } from "react-router-dom";
import { ProtectedRoute } from "../hooks/rute/ProtectedRoute";
import { LazySuspense } from "../components/layout/AppHeader/lazySuspense";
const ErrorPage = React.lazy(() => import("../components/error-page"));
const Notificaciones = React.lazy(
  () => import("../components/iu/notificacionesAbm/notificaciones"),
);
export function notificacionesAbm() {
  return (
    <Route
      path="/notificaciones-abm"
      element={
        <ProtectedRoute>
          <LazySuspense>
            <Notificaciones />
          </LazySuspense>
        </ProtectedRoute>
      }
      errorElement={
        <LazySuspense>
          <ErrorPage />
        </LazySuspense>
      }
    />
  );
}
